import { styled } from '../themes';
import Copyright from './copyright';
import InfoList from './info-list';

const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',

  '@media (max-width: 768px)': {
    flexWrap: 'wrap',
    alignItems: 'center',
    marginRight: 0,
  },

  '@media (max-width: 425px)': {
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginRight: 0,
  },
});

export default function MainContent() {
  return (
    <Container>
      <Copyright />
      <InfoList />
    </Container>
  );
}
